<div fxLayout="column" class="container coverage" fxLayoutAlign="center center">
  <h2>We deliver to over 2,800 charity locations nationwide</h2>
  <p>
    ReSupply operates in thousands of zip codes with more to come as our service areas are constantly expanding. We're committed to reaching
    even more communities, making it easier for donors everywhere to support their local charities.
  </p>
  <img src="/assets/split-screen-v3/coverage.webp" />
  <div fxLayout="column" fxLayoutAlign="center center" fxFlex="100" style="width: 100%">
    <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
      <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
      <mat-icon svgIcon="ss3-arrow-right" />
    </button>
  </div>
</div>
